export default __webpack_public_path__ + "43dbe8b8ef7a69c278abcc52b6985a97.svg";